'use strict';

import { Entity } from '../Entity';

export class UserSoaStatus extends Entity {
  protected soaStatusId;

  protected soaId;

  protected soaStatus;

  protected soaStatusDate;

  constructor() {
    super();
  }

  public hydrate(data: any) {
    this.soaStatusId = data.soaStatusId;

    this.soaId = data.soaId;

    this.soaStatus = data.soaStatus;

    if (data.soaStatusDate) {
      const soaStatusDate = data.soaStatusDate.date.split(' ')[0].split('-');
      this.soaStatusDate = soaStatusDate[1] + '/' + soaStatusDate[2] + '/' + soaStatusDate[0];
    }
  }

  public getSoaStatusId() {
    return this.soaStatusId;
  }

  public setSoaStatusId(soaStatusId) {
    this.soaStatusId = soaStatusId;

    return this;
  }

  public getSoaId() {
    return this.soaId;
  }

  public setSoaId(soaId) {
    this.soaId = soaId;

    return this;
  }

  public getSoaStatus() {
    return this.soaStatus;
  }

  public setSoaStatus(soaStatus) {
    this.soaStatus = soaStatus;

    return this;
  }

  public getSoaStatusDate() {
    return this.soaStatusDate;
  }

  public setSoaStatusDate(soaStatusDate) {
    this.soaStatusDate = soaStatusDate;

    return this;
  }
}
